<iframe  id="ERPIframe" style="width: 100%; height: 769px;" [src]="certurl | safe" title="Oracle ERP"></iframe>
